import { _ as __rest } from './tslib.es6-613ce1cd.js';
import { h } from './index-5faac9d7.js';
import { i as isRoutingDisabled } from './router-link-view-282c4d1f.js';
import { p as passBreadcrumbsParams } from './utils-5c7c3926.js';

const VARIANTS = {
  DEFAULT: 'default',
  SMALL: 'small',
};
const CARD_DESCRIPTION_MAX_HEIGHT_VARIANT_MAP = {
  [VARIANTS.DEFAULT]: '60px',
  [VARIANTS.SMALL]: '48px',
};
const CARD_NAME_MAX_HEIGHT_VARIANT_MAP = {
  [VARIANTS.DEFAULT]: '40px',
  [VARIANTS.SMALL]: '32px',
};
const CARD_LIST_MAX_SIZE_VARIANT_MAP = {
  [VARIANTS.DEFAULT]: 9,
  [VARIANTS.SMALL]: 4,
};

const RouterQdsLinkView = (props, children) => {
  const { name, url, storageName, breadcrumbs, pageName, pageId, size, importance, iconName, linkClassName, target, } = props;
  const storeBreadcrumbsParams = {
    id: pageId,
    name,
    url,
    storageName,
    breadcrumbs,
    pageName,
  };
  if (isRoutingDisabled(props)) {
    return (h("qds-standalone-link", { class: linkClassName, href: url, target: target !== null && target !== void 0 ? target : '_self', size: size, importance: importance, iconName: iconName, onClick: passBreadcrumbsParams(storeBreadcrumbsParams) }, children));
  }
  const _a = props, { routerClassName } = _a, routerProps = __rest(_a, ["routerClassName"]);
  return (h("pes-router-link", Object.assign({ key: pageId, class: routerClassName }, routerProps, { saveInIndexDB: passBreadcrumbsParams(storeBreadcrumbsParams) }),
    h("qds-standalone-link", { class: linkClassName, href: "#", size: size, importance: importance, iconName: iconName }, children)));
};

export { CARD_LIST_MAX_SIZE_VARIANT_MAP as C, RouterQdsLinkView as R, VARIANTS as V, CARD_NAME_MAX_HEIGHT_VARIANT_MAP as a, CARD_DESCRIPTION_MAX_HEIGHT_VARIANT_MAP as b };
